<template>
  <div>
    <footer>
      <p class="title">即刻开启创意之旅</p>
      <div class="btns">
        <el-button class="btn_primary" type="primary" @click="$emit('mlogin','need')">我有需求</el-button>
        <button class="btn_primary_2"  @click="$emit('mlogin','input')">我想入驻</button>
      </div>
      <div class="copy_right">
        <div class="police">
          <!-- <img class="police" :src="require('@/assets/img/badge.png')"/> -->
          <!-- 京公网安备：11010502031592 -->
        </div>
        <div><a href="https://beian.miit.gov.cn/" target="_blank" style="color:rgba(255, 255, 255, 0.6)" >京ICP备14034088号-17</a>
          <img style="width:16px;margin-left: 10px;padding-right:3px;vertical-align:middle;" :src="require('@/assets/img/beian_jgwab.png')"/><a href="https://beian.mps.gov.cn/#/query/webSearch?code=11010502055420" rel="noreferrer" target="_blank" style="color:rgba(255, 255, 255, 0.6)">京公网安备11010502055420</a>
        </div>
        <div>Copyright © 2011-{{year}} 时趣互动 版权所有</div>
      </div>
    </footer>
  </div>
</template>
<script>
/* eslint-disable */
export default {
  name: 'Footer',
  data() {
    return {
      year: new Date().getFullYear(),
    }
  }
}
</script>




// WEBPACK FOOTER //
// src/components/Footer.vue